/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_TimecodeInputs */



/**
* | output |
* | --- |
* | "TIMECODE" |
*
* @param {Ccsl_Export_Header_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_timecode = /** @type {((inputs?: Ccsl_Export_Header_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("TIMECODE")
	if (locale === "de") return /** @type {LocalizedString} */ ("TIMECODE")
	if (locale === "it") return /** @type {LocalizedString} */ ("CODICE ORARIO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ТАЙМКОД")
	if (locale === "es") return /** @type {LocalizedString} */ ("CÓDIGO DE TIEMPO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("CÓDIGO DE TEMPO")
	return /** @type {LocalizedString} */ ("TIMECODE")
});